import { render } from "./Drawer.vue?vue&type=template&id=6d06b787"
import script from "./Drawer.vue?vue&type=script&lang=js"
export * from "./Drawer.vue?vue&type=script&lang=js"

import "./Drawer.vue?vue&type=style&index=0&id=6d06b787&lang=scss"
script.render = render

export default script